<template>
    <div>
        <!-- 文章 -->
        <div class="subject-listcontent">
            <div class="list" v-for="(items, indexs) in topic_article_list" :key="indexs"
                @click="$navigate('/subject/info', items.ttar_id)">
                <div class="t1s df jcsb aic over-h">
                    <div class="mic-semblod one-text" style="max-width: calc(100% - 180px);">
                        <span class="essence" v-if="items.ttar_rec == 900">{{ $t("精1") }}</span>

                        <!-- <span class="hot">{{ $t("热") }}</span> -->
                        <span class="hot" style="background-color: #fdb906ff" v-if="items.ttar_rec == 1000">{{
                            $t("顶1")
                        }}</span>

                        {{ items.ttar_title }}

                    </div>
                </div>

                <div class="btn-boxs">
                    <el-button class="btn" @click="handleEdit($event,items)">{{$t("编辑")}}</el-button>
                    <el-button class="btn" @click="handleDelete($event,items.ttar_id)">{{$t("删除")}}</el-button>
                </div>

                <!-- 审核图片 -->
                <div class="chapter-img" v-if="items && items.ttar_status">
                    <!-- 根据语言和状态动态加载图片 -->
                    <img
                        :src="getImageSrc(items.ttar_status)"
                        v-if="!currLanguage"
                        alt
                    />
                    <img
                        :src="getImageSrc(items.ttar_status, true)"
                        v-else
                        alt
                    />
                </div>

                <div class="desc tow-text" :title="items.ttar_desc">
                    {{ items.ttar_desc }}
                </div>

                <div class="userinfo-box df jcsb aic over-h">
                    <div class="users df aic f1 over-h">
                        <div @click="(event) => handleaAvatar(event, items)" class="df">
                            <template v-if="items.ttar_type == 10">
                                <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                    @error="$erroravatarHandler">
                                    <img src="@/assets/images/avatar.png" alt="" />
                                </el-avatar>
                            </template>
                            <template v-else>
                                <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                    class="fn"></el-avatar>
                            </template>
                        </div>
                        <span class="name fn">
                            {{
                                items.is_expert == 10
                                    ? items.user_name
                                    : items.ttar_type == 20 ||
                                        items.user_id == 0 ||
                                        items.user_nick_name === "" ||
                                        items.user_nick_name === null
                                        ? $t("匿名用户")
                                        : items.user_nick_name
                            }}
                        </span>

                        <div class="f1 type one-text" v-if="items.user_excel_arr.length">
                            <span v-for="items1 in items.user_excel_arr" :key="items1.label">{{
                                items1.label }}</span>
                        </div>
                    </div>

                    <div class="dates df fn">
                        <div class="comment-list df">
                            <div class="li">
                                <span class="iconfont">&#xe611;</span>
                                <span class="text">{{ items.ttar_hits }}</span>
                            </div>
                            <div class="li">
                                <span class="iconfont">&#xe61b;</span>
                                <span class="text">{{ items.ttar_likes }}</span>
                            </div>
                            <div class="li">
                                <span class="iconfont">&#xe63e;</span>
                                <span class="text">{{ items.reply_count }}</span>
                            </div>
                        </div>
                        <span class="date">{{ items.create_time }}</span>
                    </div>
                </div>
            </div>
            <div class="pageing-box df aic jcc" v-if="topic_article_list.length > 0">
                <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>
                <el-pagination :current-page="pagination.page" :page-size="pagination.per_page"
                    :total="pagination.total" layout=" prev, pager, next,slot" @current-change="handleCurrent">
                    <span class="jump-text">{{ $t('跳转') }}</span>
                    <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages"
                        @change="handleJump" size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />
                </el-pagination>
                <el-button type="text" class="add-btn ml-11"
                    @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
            </div>
            <div class="no-data pt-86" v-if="topic_article_list.length == 0">
                <img src="@/assets/images/empty_data.png" alt="" />
                <p>{{ $t("暂无数据") }}</p>
            </div>
        </div>

        <!-- 删除 -->
        <el-dialog :title="$t('温馨提示')" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
            <div>
                <span class="iconfont mr-6" style="color: #B7251E;">&#xe677;</span>
                <span>{{ $t("确认删除") }}?</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t("取消") }}</el-button>
                <el-button type="primary" @click="handleDeleteList(false)">{{ $t("确定") }}</el-button>
                <el-button type="primary" @click="handleDeleteList(true)">{{ $t("删除全部语言版本") }}</el-button>
            </span>
        </el-dialog>

        <!-- update:ttarId -->
       <!-- 子组件使用的 this.$emit('update:ttarId', ''); -->
        <articleModel ref="articleDialog" :ttarId="ttar_id" @update:ttarId="(newValue) => ttar_id = newValue"
        @post-submitted="handlePostSubmitted" />
        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />
    </div>
</template>

<script>
import { article,editArticle,DelArticle } from "@api/usercenter";
import articleModel from './articleModel.vue';
import { setuserfollowAdd,userDataLv2 } from "@api/home";
export default {
    components: {
        articleModel,
    },
  
    data() {
        return {
            pagination: {
                page: 1,
                total: 0,
                per_page: 0,

            },
            totalPages: 0, //总页数
            jumpIndex: '',
            dialogVisible:false,

            thumbsId:"",
            tablist:[],

            // 话题列表
            topic_article_list: [],
            currLanguage: "cn",
            // 是否是英文版
            currentLanguage: "cn",
            ttar_id:0,

            // 删除 id
            delete_id:"",
            id: 0,
        }
    },

    created() {
        // console.log(1111111111111)
        // this.getData();
    },
    mounted() {
        this.getData();
        let Language = localStorage.getItem("currentLanguage"); // 获取本地语言
        this.currLanguage = Language && Language !== "zh";
    },
    
    methods:{
        // 跳转
        handleJump() {
            this.pagination.page = this.jumpIndex;
            this.getData();
        },
        handleClose(){
            this.dialogVisible=false;

        },

        // 删除
        handleDelete(e,id){
            this.delete_id=id;
            // 阻止冒泡
            e.stopPropagation();
            this.dialogVisible=true;

        },

        // 确认删除
        handleDeleteList(all=false){
            let obj = {
                ttar_id: this.delete_id,
				delete_all: all == true ? 10 : 0,
				dataOrigin: true
            }

            DelArticle(obj).then((res) => {
                if (res.status == 200) {
                    this.$message.success(res.msg);
                    this.getData()
                    this.dialogVisible=false;
                } 
            })

            // all  删除全部语言版本  

        },

        async getData() {
            const loading = this.$loading({
                lock: true,
                text: this.$t('拼命加载中'),
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            const articleData = await article({page: this.pagination.page});
            if (articleData.status == 200) {
                loading.close();
                this.topic_article_list = articleData.data.data
                this.pagination.total = articleData.data.total;
                this.pagination.per_page = articleData.data.per_page;
                this.totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
            }
        },
        handlePages(index) {
            this.pagination.page = index;
            this.getData();
        },
        // 分页改变
        handleCurrent(val) {
            this.pagination.page = val;
            this.getData();
        },
        filterStatus(status) {
            return status === 30 ? 'err-ai' : status;
        },
        getImageSrc(status, isEn = false) {
            const filteredStatus = this.filterStatus(status);
            if (isEn) {
            return require(`@/assets/images/chapter_en/chapter-${filteredStatus}.png`);
            }
            return require(`@/assets/images/chapter/chapter-${filteredStatus}.png`);
        },
        handleEdit(event,items){
            // 阻止冒泡
            event.stopPropagation();
            this.$refs.articleDialog.openModal();
            this.ttar_id = items.ttar_id
            
        },

        // 
        async handlePostSubmitted(formData){
            formData.other_lang[0] = formData.other_lang[0] ? 2 : 0;
            formData.other_lang[1] = formData.other_lang[1] ? 3 : 0;
            const res = await editArticle(formData);
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
            this.getData()
            
        },
        handleaAvatar(event, item) {
            // 判断是否是实名用户
            if (item.ttar_type == 20 || item.user_id == 0 || item.user_nick_name == '' || item.user_nick_name == null) {
                return false;
            }
            event.stopPropagation(); // 阻止事件冒泡
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;

        },
        async handleAvatarSubmitted(id) {
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
// 话题列表
.subject-listcontent {
    margin-top: 18px;

    .chapter-img{
        position: absolute;
        right: 20px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        top: 68px;
        z-index: 2;
        margin-left: 6px;
        img{
            width: 64px;
        }
    }
    .pageing-box {
        margin-top: 24px;
        padding-bottom: 120px;
    }
    .btn-boxs {
        position: absolute;
        right: 0;
        top: 16px;

        .btn {
            height: 32px;
            line-height: 30px;
            padding: 0 26px;
            color: #868d9f;
            font-size: 12px;
            border-radius: 30px;

            &:hover {
                color: #b7251e;
            }
        }
    }

    .list {
        position: relative;
        padding: 16px 0px;
        border-bottom: 1px solid rgb(226, 226, 226);
        cursor: pointer;
        transition: border-bottom 0.36s;
        z-index: 10;

        &:hover {
            border-bottom: 1px solid #b7251e;

            .t1s {
                color: #b7251e;
            }
        }

        .t1s {
            color: rgb(25, 25, 25);
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            padding: 2px 0;

            .essence,
            .hot {
                display: inline-block;
                min-width: 18px;
                height: 18px;
                border-radius: 2px;
                font-size: 14px;
                color: #ffffff;
                line-height: 18px;
                text-align: center;
                margin-right: 4px;
                position: relative;
                padding: 0 2px;
                top: -1px;
            }

            .essence {
                background: rgb(215, 17, 17);
            }

            .hot {
                background: rgb(255, 110, 0);
            }

            .show-box {
                img {
                    margin-left: 6px;
                }
            }
        }

        .desc {
            color: rgb(51, 51, 51);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            height: 44px;
            margin-top: 10px;
        }
    }

    .hot-box,
    .essence-box {
        position: relative;

        &::after {
            content: "";
            display: block;
            width: 400px;
            height: calc(100% + 1px);
            opacity: 0.6;
            position: absolute;
            right: -40px;
            top: 0;
        }
    }

    .essence-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(254, 190, 8, 0.21) -2.449%,
                    rgba(196, 196, 196, 0) 96.756%);
        }
    }

    .hot-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(255, 0, 0, 0.11) -2.446%,
                    rgba(196, 196, 196, 0) 96.716%);
        }
    }

    .userinfo-box {
        height: 32px;
        margin-top: 8px;

        .name {
            font-size: 14px;
            margin-left: 6px;
        }
    }

    .type {
        height: 32px;
        position: relative;
        margin-left: 18px;
        padding: 5px 18px;

        &::after {
            content: "";
            display: block;
            height: 14px;
            width: 1px;
            background-color: #d8d8d8;
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 0;
        }

        span {
            display: inline-block;
            height: 22px;
            background-color: #f0f1f1;
            border-radius: 4px;
            padding: 0 4px;
            color: #868d9f;
            line-height: 22px;
            font-size: 12px;
            margin-right: 6px;
        }
    }

    .dates {
        height: 32px;
        line-height: 32px;

        .date {
            font-size: 14px;
            color: #868d9f;
            position: relative;
            padding-left: 16px;

            &::after {
                content: "";
                display: inline-block;
                height: 12px;
                width: 1px;
                background-color: #d8d8d8;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -6px;
            }
        }

        .comment-list {
            .li {
                color: #868d9f;
                font-size: 14px;
                margin-right: 15px;

                .iconfont {
                    margin-right: 5px;
                }

                .text {}
            }
        }
    }
}
</style>